import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { json2excel } from 'js2excel';
import { withRouter } from 'react-router-dom';
import moment from 'moment';

import Button from '@material-ui/core/Button';
import { Grid } from '@material-ui/core';

import styled from 'styled-components';
import StockTable from './table/StockTable';
import { Title } from '../style';
import { getStock, getRequiredAttributes } from './stockActions';
import { displaySuccess, displayError } from '../../utils/toast/Toast';
import logger from '../../utils/logger';
import StockItemDrawer from './components/drawer/StockItemDrawer';

const CustomPaper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: 20px;
`;

const renameKeys = (obj, newKeys) => {
  const keyValues = Object.keys(obj).map(key => {
    const newKey = newKeys[key] || key;
    return { [newKey]: obj[key] };
  });
  return Object.assign({}, ...keyValues);
};

/**
 * @desc Récupération et affichage du stock
 */
const Stock = ({
  companyStock,
  dispatchGetStock,
  dispatchGetRequiredAttributes,
  currentUser,
  watchUpdateStock
}) => {
  useEffect(() => {
    dispatchGetStock(currentUser.company.id);
    dispatchGetRequiredAttributes();
  }, [
    dispatchGetStock,
    dispatchGetRequiredAttributes,
    currentUser.company.id,
    watchUpdateStock
  ]);

  const generateExcel = () => {
    const keyBinding = {
      reference: 'Référence',
      barcodeValue: 'EAN13',
      name: 'Désignation',
      color: 'Couleur',
      size: 'Taille',
      quantity: 'Quantité physique',
      bufferQuantity: 'Quantité buffer',
      initialBufferQuantity: 'Quantité buffer initiale',
      forecastQuantity: 'Quantité prévisionnelle'
    };
    try {
      json2excel({
        data: companyStock.map(product => renameKeys(product, keyBinding)),
        name: `stock-sympl-${moment().format('YYYY-MM-DD')}`
      });
      displaySuccess('Téléchargement de votre stock réussi');
    } catch (error) {
      displayError(0);
      logger(error);
    }
  };
  return (
    <div>
      <Grid container spacing={10} alignItems="center">
        <Grid item md={3}>
          <Title>Stock</Title>
        </Grid>
        <Grid item md={9}>
          {/* <ButtonContainer>
            <Button
              variant="contained"
              color="primary"
              onClick={() => history.push('/import-products')}
            >
              Importer des produits
            </Button>
          </ButtonContainer> */}
        </Grid>
      </Grid>
      <CustomPaper>
        <Button color="primary" variant="contained" onClick={generateExcel}>
          Exporter
        </Button>
        <Button
          color="primary"
          variant="contained"
          onClick={() => dispatchGetStock(currentUser.company.id)}
          style={{ marginLeft: 30 }}
        >
          Actualiser
        </Button>
      </CustomPaper>
      <StockItemDrawer />
      <StockTable />
    </div>
  );
};

Stock.propTypes = {
  companyStock: PropTypes.array,
  currentUser: PropTypes.object.isRequired,
  dispatchGetStock: PropTypes.func.isRequired,
  dispatchGetRequiredAttributes: PropTypes.func.isRequired,
  watchUpdateStock: PropTypes.bool.isRequired
};

const mapStateToProps = state => ({
  companyStock: state.stock.companyStock,
  currentUser: state.init.currentUser,
  watchUpdateStock: state.stock.watchUpdateStock,
  requiredAttributes: state.stock.requiredAttributes
});

const mapDispatchToProps = dispatch => ({
  dispatchGetStock: companyId => dispatch(getStock(companyId)),
  dispatchGetRequiredAttributes: () => dispatch(getRequiredAttributes())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Stock));
